<div class="request-wrapper" *ngIf="request && !isLoading">

    <div class="request-header">
        <div class="request-user">
            <app-avatar [imgUrl]="requestingParty?.imgURL" />
            <div class="name">
                {{fromUser?.displayName}}
            </div>
        </div>
        <div class="request-title">wants to connect about a flight</div>
    </div>

    <app-section-label weight="100" mb="8px" mobileSize="14px">Based on your travel plans:</app-section-label>

    <app-flight-option-card [showHeader]="false" [showSeats]="false" [flightOption]="flightOption"></app-flight-option-card>

    <div id="request-animate">

    <app-section-label weight="100" mb="8px" mobileSize="14px">Request Details</app-section-label>

    <app-base-card>
        <div class="request-text flex a-center">
            <div>
                They need <span class="highlight">&nbsp;{{request.seatsRequested}}&nbsp;</span> seats for this flight.
            </div>
        </div>
    </app-base-card>

    <app-section-label weight="100" mb="8px" mt="18px" mobileSize="14px">Message</app-section-label>

    <app-base-card>
        <div class="flex message-text">
            <!-- // TODO: Spend time making small avatar work -->
            <!-- <app-avatar [imgUrl]="requestingParty?.imgURL" size="20px" /> -->
            "{{request.requestMessage}}"
        </div>
    </app-base-card>

    </div>

    <div class="button-wrapper">
        <app-primary-btn mb="12px" [disabled]="isAccepting || isDeclining" [isLoading]="isAccepting" (click)="onClickAccept()">
            Accept and Connect
        </app-primary-btn>
        <app-secondary-btn [disabled]="isDeclining || isAccepting" [isLoading]="isDeclining" (click)="onClickDecline()" [destructive]="true">
            Decline
        </app-secondary-btn>
    </div>

</div>
